// ============================================================================
// PairsForm — DialogMobile : Dialog plein écran sur mobile (plan R0.2)
// ============================================================================
// Doctrine responsive §2 : tout Dialog portant un formulaire passe plein
// écran sous `md` (un modal de 300 px utiles avec des champs côte à côte est
// insaisissable au doigt). Défauts : `fullWidth` + `maxWidth="sm"`. Tout
// reste surchargeable par props (y compris `fullScreen` si un appelant veut
// forcer l'un ou l'autre comportement).
//
// Adoption : composant à utiliser pour tout NOUVEAU dialog-formulaire ; les
// 149 dialogs existants migrent par lots de parcours (R1-R3), pas d'un bloc.

import { Dialog, type DialogProps } from "@mui/material";
import { useIsMobile } from "../../hooks/useIsMobile";

export function DialogMobile({ fullWidth = true, maxWidth = "sm", ...props }: DialogProps) {
  const isMobile = useIsMobile();
  return <Dialog fullScreen={isMobile} fullWidth={fullWidth} maxWidth={maxWidth} {...props} />;
}
